export default __webpack_public_path__ + "static/media/team1.66a690b5.png";